import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import AddNewCommodityForm from "../forms/AddNewCommodityForm";

interface props {
  isVisible: boolean;
  handleClose: () => void;
}

const NewCommodityContainer = ({ isVisible, handleClose }: props) => {
  if (!isVisible) {
    return null;
  }

  return (
    <>
      <CustomDialog
        isOpen={true}
        handleClose={handleClose}
        title="Crear Commodity"
        hideActionButtons
      >
        <AddNewCommodityForm />
      </CustomDialog>
    </>
  );
};

export default NewCommodityContainer;
